import React from "react";
import Divider from "./Divider";
import EditCoachingPlanHead, { ViewState } from "./EditCoachingPlanHead";
import WeeklyPlanEditor from "./WeeklyPlanEditor";
import PersonalRoutineEditor from "./PersonalRoutineEditor";

const CompletedCurrentWeekView = ({
    activityStats,
    selectedWeek,
    weekOptions,
    coachingPlan,
    personalRoutine,
    name,
    routineScoreData,
    constPlan = null,
    constRoutine = null,
    // Callbacks
    onChangeWeek,
    onStartNewPlan
}) => {
    return (
        <div className="w-[100%] p-10 flex-col justify-center items-center gap-y-6 inline-flex">
            <div id="head" className="w-full justify-center items-center gap-x-3 inline-flex">
                <EditCoachingPlanHead
                    coachingPlan={coachingPlan}
                    selectedWeek={selectedWeek}
                    state={ViewState.Interrupted}
                    weekOptions={weekOptions}
                    // Callbacks
                    onStartNewPlan={onStartNewPlan}
                    setSelectedWeekCallback={onChangeWeek}
                />
            </div>
            <div id="divider" className="w-full justify-center items-center gap-x-3 inline-flex bg-green-100">
                <Divider label={"Assignments"}/>
            </div>
            <div id="divider" className="w-full justify-center items-center gap-3 inline-flex rounded-[10px] shadow border border-gray-200">
                <PersonalRoutineEditor
                    activityStats={activityStats}
                    constRoutine={constRoutine}
                    firstName={name}
                    personalRoutine={personalRoutine}
                    routineBadgeData={routineScoreData}
                    selectedWeek={selectedWeek}
                    state={ViewState.Interrupted}
                />
            </div>
            <div id="divider" className="w-full justify-center items-center gap-3 inline-flex rounded-[10px] shadow border border-gray-200">
                <WeeklyPlanEditor
                    activityStats={activityStats}
                    coachingPlan={coachingPlan}
                    constPlan={constPlan}
                    selectedWeek={selectedWeek}
                    state={ViewState.Interrupted}
                />
            </div>
        </div>
    );
};

export default CompletedCurrentWeekView;